<div
  class="footer-snackbar-desktop ng-scope w-100"
  style="position: fixed; bottom: 0px; left: 0px; z-index: 2"
>
  <div class="container">
    <div class="row">
      <div
        class="col-12"
        *ngIf="!doShowSelectPlanCopy() && !isSelectPlan()"
      >
        <ul>
          <li>
            <div class="gb-body1 invert heavy automation-plan-name">
              <a
                (click)="openDisclosureModal(); fireTracking(getPlanName())"
                class="gb-body1 mb-0 automation-disclosure-link"
                role="button"
                [attr.aria-label]="'footer_plan_disclosure_label' | translate"
                [attr.data-toggle]="'modal'"
                [attr.data-target]="'#planDisclosure'"
                >
                {{ getPlanName() }}
                <sup>†</sup>
              </a>
            </div>
          </li>
          <li>
            <div class="pricing-large">
              <div class="price gb-body1">
                <div class="gb-body1 heavy invert mb-0 sup" *ngIf="language !== 'fr'">
                  $
                </div>
                <div class="gb-body1 heavy invert mb-0 mx-1" style="font-size: 3rem">
                  {{ getDollars() }}
                </div>
                <div class="d-flex flex-column">
                  <div class="gb-body1 heavy invert mb-1 sup">
                    <span *ngIf="language !== 'fr'">.</span
                    ><span *ngIf="language === 'fr'">,</span>{{ getCents() }}
                  </div>
                  <div class="gb-body2 invert" *ngIf="!isData">
                    <span
                      *ngIf="isMonthly"
                      [translate]="'plan_details_perMonth'"
                    ></span>
                    <span
                      *ngIf="!isMonthly"
                      [translate]="'plan_details_perYear'"
                    ></span>
                  </div>
                </div>
                <div class="gb-body1 heavy invert mb-0 sup" *ngIf="language === 'fr'">
                  $
                </div>
                <a
                  [attr.data-toggle]="'modal'"
                  (click)="openPriceDisclosureModal()"
                  [attr.data-target]="'#footerPriceDisclosure'"
                  class="gb-body1 invert mb-0 automation-disclosure-link"
                  role="button"
                  [attr.aria-label]="'footer_plan_disclosure_label' | translate"
                >
                  <sup>†</sup>
                </a>
              </div>
            </div>
          </li>
          <li>
            <button
              type="button"
              class="gb-primary-button invert automation-cta"
              [ngClass]="{white: buttonLoading}"
              [disabled]="buttonLoading"
              (click)="buttonClick()"
              [attr.aria-label]="'footer_checkout_button' | translate"
            >
              <span *ngIf="!buttonLoading">{{ buttonName }}</span>
              <div *ngIf="buttonLoading">
                <ox-loading></ox-loading>
              </div>
            </button>
          </li>
        </ul>
      </div>
      <!-- <div class="col-12" *ngIf="deselected"><p>Select a different plan to continue.
				If you no longer wish to change your plan, then return to <a href="*"> My Plans</a>
			</p></div> -->
      <!-- <div class="col-12 text-center" *ngIf="planCount > 0"><p>{{planCount}} Plans</p></div> -->

      <div class="col-12" *ngIf="doShowSelectPlanCopy()">
        <p class="text-center m-0">
          Select one of the plans above to continue.
        </p>
      </div>
      <div class="col-12" *ngIf="isSelectPlan()">
        <p class="text-center m-0">
          Select another plan of the plans above to continue.
        </p>
      </div>
    </div>
  </div>
</div>
<div class="footer-snackbar-mobile-wrapper">
  <div class="footer-snackbar-mobile">
    <div class="container">
      <div class="row">
        <div
          class="col-12"
          *ngIf="!(planName === '' && planCount === 0) && !isSelectPlan()"
        >
          <div class="footer-snackbar-mobile">
            <div class="title gb-body2 invert">
              <div class="gb-body1 invert heavy automation-plan-name">
                <a
                  role="button"
                  class="gb-body1 mb-0 automation-disclosure-link"
                  (click)="openDisclosureModal(); fireTracking(getPlanName())"
                  [attr.aria-label]="'footer_plan_disclosure_label' | translate"
                  [attr.data-toggle]="'modal'"
                  [attr.data-target]="'#planDisclosure'"
                  >
                  {{ getPlanName() }}
                  <sup>†</sup>
                </a>
              </div>

              <a
                [attr.data-toggle]="'modal'"
                [attr.data-target]="'#footerPriceDisclosure'"
                class="gb-body1 mb-0 automation-disclosure-link"
                role="button"
                (click)="openPriceDisclosureModal()"
                [attr.aria-label]="'footer_plan_disclosure_label' | translate"
              >
                <span class="heavy">{{ price | currency }}</span>
                <span class="" *ngIf="!isData && !doHideFrequencyText">
                  <span
                    *ngIf="isMonthly"
                    translate="plan_details_perMonth"
                    [translate]="'plan_details_perMonth'"
                  ></span>
                  <span
                    *ngIf="!isMonthly"
                    translate="plan_details_perYear"
                    [translate]="'plan_details_perYear'"
                  ></span>
                </span>
                <sup>†</sup>
              </a>
            </div>
            <div>
              <button
                class="gb-primary-button invert automation-cta"
                [attr.aria-label]="'footer_checkout_button' | translate"
                (click)="buttonClick()"
                [ngClass]="{white: buttonLoading}"
              >
                <span *ngIf="!buttonLoading">{{ buttonName }}</span>
                <ox-loading *ngIf="buttonLoading"></ox-loading>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12" *ngIf="doShowSelectPlanCopy()">
          <p class="text-center m-0">
            Select one of the plans above to continue.
          </p>
        </div>
        <div class="col-12" *ngIf="isSelectPlan()">
          <p class="text-center m-0">
            Select another plan of the plans above to continue.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
